
import scrool3 from "../assets/partner/scrool3.webp"
import scrool1 from "../assets/partner/scrool1.webp"
import scrool2 from "../assets/partner/scrool2.webp"

export const items = [
  {
    image: scrool2,
    name: "Education is not Prepration for life ",
    desc: "Education is life ",
  },
  {
    image: scrool1,
    name: "Develop a passion for learning",
    desc: "will never cease to grow",
  },
  {
    image: scrool3,
    name: "A Teacher takes a hand,opens a mind ",
    desc: "And Touches ",
  },
 
];
